import {
    Button,
    CircularProgress,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import BasvuruTuruAPI, { BasvuruTuruRequest } from "../../../apis/OB/Get/BasvuruTuruAPI";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomTextField from "../../../components/OB/required-text-field";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Recaptcha from "../../../components/Recaptcha";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import kullaniciAdresGetAPI from "../../../apis/KullaniciYonetimi";

const validationSchema = Yup.object({
    basvuruTuru: Yup.number().required("Başvuru türü zorunludur"),
    aciklama: Yup.string().required("Açıklama zorunludur"),
});

const DigerOnlineBasvurular = (props: any) => {

    const [isLoad, setIsLoad] = useState(true);
    const navigate = useNavigate();
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupbasvuruMetni, setPopupbasvuruMetni] = useState("");
    const [kayitBasarili, setKayitBasarili] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>('');
    const [userControlPopup, setUserControlPopup] = useState(false);

    interface BasvuruTuruOption {
        basvuruTuruId: number;
        basvuruTuruAdi: string;
    }

    // başvuru türleri listeleme
    const [basvuruTurleri, setBasvuruTurleri] = useState<BasvuruTuruOption[]>([]);
    // başvuru türü seçme
    const [selectedBasvuruTuru, setSelectedBasvuruTuru] = useState<number | null>(null);

    const user = SessionStorageService.getUserInfo();
    useEffect(() => {
        if (user == null) {
            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }

    }, []);

    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    }

    const initialRows = [
        { id: 1, documentName: "Belge 1", isRequired: true },
        { id: 2, documentName: "Belge 2", isRequired: false },
    ];
    const [documents, setDocuments] = useState(initialRows);
    const handleUpdateDocuments = (updatedDocuments: any) => {
        setDocuments(updatedDocuments);
    };

    const closePopupSonuc = () => {
        setIsPopupVisible(false);
        setPopupbasvuruMetni("");
    };

    // başvuru türü
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const response = await BasvuruTuruAPI.getBasvuruTuruListe();
                console.log("response", response);
                const rawList = response.data ?? [];
                const list = rawList.map((o: any) => ({
                    basvuruTuruId: o.basvuruTuruId,
                    basvuruTuruAdi: o["basvuruTuruAdi"] ?? o.aciklama ?? ""
                }));
                setBasvuruTurleri(list);
            } catch (err) {
                console.error(err);
                setMessage("Başvuru türleri alınırken hata oluştu.");
                setBasvuruTurleri([]);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    return (
        isLoad ? <>
            <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
            {userControlPopup ? (

                <AciklamaAndUserControlPopup
                    open={userControlPopup}
                    handleClose={closeUserControlPopup}
                    isUserControlPopUp={true}
                    description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
                />

            ) : null}
        </> :
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                validateOnMount={true}
                initialValues={{
                    basvuruTuru: null,
                    aciklama: "",
                }}
                onSubmit={async (values: any, { resetForm }) => {

                    const transformedValues = {
                    };

                    // api çağırılacak
                }}
            >

                {(formikProps) => {

                    return (
                        <Form>
                            <div className="mb-3 d-flex justify-content-end">
                                <Button
                                    type="button"
                                    onClick={() =>
                                        formikProps.resetForm({ values: formikProps.initialValues })
                                    }
                                    color="secondary"
                                >
                                    Temizle
                                </Button>
                            </div>

                            <div className="card shadow-none border w-100 mb-4">
                                <div className="bg-white px-3 py-1 small fw-semibold">
                                    DİĞER ONLİNE BAŞVURULAR
                                </div>
                                <div className="card-body">

                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <CustomTextField
                                                name="basvuruTuru"
                                                fullWidth
                                                select
                                                displayEmpty
                                                label="Basvuru Türü *"
                                                size="small"
                                                error={
                                                    formikProps.errors.basvuruTuru &&
                                                        formikProps.touched.basvuruTuru
                                                        ? true
                                                        : false
                                                }
                                                value={formikProps.values.basvuruTuru}
                                                onChange={(e: any) => {
                                                    const val = Number(e.target.value);
                                                    formikProps.setFieldValue("basvuruTuru", val);
                                                    setSelectedBasvuruTuru(val);
                                                }}

                                            >
                                                <MenuItem selected value={null as any}>
                                                    {"Seçiniz.."}
                                                </MenuItem>
                                                {basvuruTurleri.map((option) => (
                                                    <MenuItem
                                                        key={option.basvuruTuruId}
                                                        value={option.basvuruTuruId}
                                                    >
                                                        {option.basvuruTuruAdi}
                                                    </MenuItem>
                                                ))}
                                            </CustomTextField>
                                        </div>
                                        <div className="col-md-6">
                                            <CustomTextField
                                                label="Açıklama *"
                                                rows={5}
                                                fullWidth
                                                multiline
                                                size="small"
                                                InputProps={{ style: { height: "100%" } }}
                                                error={
                                                    formikProps.errors.aciklama &&
                                                        formikProps.touched.aciklama
                                                        ? true
                                                        : false
                                                }
                                                {...formikProps.getFieldProps("aciklama")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4"><DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} /></div>

                            <div className="d-flex justify-content-end">
                                <Button
                                    type="submit"
                                >
                                    Gönder
                                </Button>
                            </div>

                            {isPopupVisible ? (
                                <BilgilendirmePopup
                                    basvuruTuruId={formikProps.values.basvuruTuruId}
                                    isSorunBildirPopup={!kayitBasarili}
                                    closePopup={closePopupSonuc}
                                    open={isPopupVisible}
                                    editDescription={popupbasvuruMetni}
                                />
                            ) : null}


                        </Form>
                    );
                }}
            </Formik>
    );
};
export default DigerOnlineBasvurular;
